import { Zero, Components, Logger } from 'Zero';
import { GoogleMap } from 'Vendor/@openmind/storelocator/dist/googlemap.umd.js';
import StoreLocator from 'Vendor/@openmind/storelocator/dist/storelocator.umd.js';
import LoaderUtil from '../utils/LoaderUtil';
import { SmoothScroll } from '../utils/SmoothScroll';

const Log = new Logger('ZDetail');

export default class ZDetail extends Components {
  get Messages() {
    return {
      'StoreLocator:Init': this.onStoreLocatorInit,
    };
  }

  get Selectors() {
    return {
      DetailTemplate: '#dealer-detail-template',
      DetailResultContainer: '#detail-result-container',
      ZoomIn: '#detail-controls_zoom_in',
      ZoomOut: '#detail-controls_zoom_out',
      DetailMap: '#detail-map',
      // BaGoto: '.js-goto-ba',
      // BaTarget: '#bookAppointment'
    };
  }

  onStoreLocatorInit(msg) {
    this.StoreLocator = msg.StoreLocator;
  }

  getMarkerUrl() {
    switch (this.subBrand) {
      case 'PERSONA':
        return this.data.marker.icon.personaUrl;
        break;
      case 'MARINA_RINALDI':
        return this.data.marker.icon.marinarinaldiUrl;
        break;
      default:
        return this.data.marker.icon.Url;
    }
  }

  onInitDetailMap(msg) {
    const d_Lat = this.data.lat;
    const d_Lng = this.data.lng;
    const _styles = [
      { elementType: 'geometry', stylers: [{ color: '#f5f5f5' }] },
      { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
      { elementType: 'labels.text.fill', stylers: [{ color: '#616161' }] },
      { elementType: 'labels.text.stroke', stylers: [{ color: '#f5f5f5' }] },
      {
        featureType: 'administrative.land_parcel',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#bdbdbd' }],
      },
      {
        featureType: 'poi',
        elementType: 'geometry',
        stylers: [{ color: '#eeeeee' }],
      },
      {
        featureType: 'poi',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#757575' }],
      },
      {
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [{ color: '#e5e5e5' }],
      },
      {
        featureType: 'poi.park',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#9e9e9e' }],
      },
      {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [{ color: '#ffffff' }],
      },
      {
        featureType: 'road.arterial',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#757575' }],
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry',
        stylers: [{ color: '#dadada' }],
      },
      {
        featureType: 'road.highway',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#616161' }],
      },
      {
        featureType: 'road.local',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#9e9e9e' }],
      },
      {
        featureType: 'transit.line',
        elementType: 'geometry',
        stylers: [{ color: '#e5e5e5' }],
      },
      {
        featureType: 'transit.station',
        elementType: 'geometry',
        stylers: [{ color: '#eeeeee' }],
      },
      {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [{ color: '#c9c9c9' }],
      },
      {
        featureType: 'water',
        elementType: 'geometry.fill',
        stylers: [{ color: '#fcf6e7' }],
      },
      {
        featureType: 'water',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#9e9e9e' }],
      },
    ];

    let detailMap = new google.maps.Map(this.MapEl[0], {
      zoom: 16,
      center: { lat: d_Lat, lng: d_Lng },
      styles: _styles,
      disableDefaultUI: true,
      scaleControl: true,
      gestureHandling: 'cooperative',
    });

    const detail_marker = {
      url: this.getMarkerUrl(),
      scaledSize: new google.maps.Size(
        this.data.marker.icon.Size.h,
        this.data.marker.icon.Size.w
      ),
    };

    let detailMarker = new google.maps.Marker({
      position: { lat: d_Lat, lng: d_Lng },
      map: detailMap,
      icon: detail_marker,
    });

    this.element.addClass('is-visible');

    this.ZoomIn.on('click.zmap', e => {
      detailMap.setZoom(detailMap.getZoom() + 1);
      e.stopImmediatePropagation();
    });

    this.ZoomOut.on('click.zmap', e => {
      detailMap.setZoom(detailMap.getZoom() - 1);
      e.stopImmediatePropagation();
    });
  }

  // goToBookAppointment() {
  //   if(this.BaTarget || this.BaGoto) {
  //     let self = this;

  //     this.BaGoto.on('click.gotobo', (e) => {
  //       e.preventDefault;
  //       const BToffset = self.BaTarget.offset().top - 300;
  //       SmoothScroll(window, BToffset , 0, 'smooth')
  //     })
  //   }
  // }

  setDetailContentDimensions(msg) {
    let headerHeight = msg;
    let detailHeader = $('.mc-sl-detail-header');
    let detailContent = $('.store-details-content');

    detailHeader.css({ display: 'block' });
    let detailHeaderHeight = detailHeader.outerHeight(true);

    if (detailHeaderHeight) {
      detailContent.css({ 'padding-top': detailHeaderHeight });
    }
  }

  // da bindare controllo privacy booking tool
  basicPrivacyAcceptance() {
    let isDisabled = true;

    $('input[name="isPrivacy').attr('checked', false);

    $('body').on('change.bpr', 'input[name="isPrivacy"]', function(e) {
      if ($('input[name="isPrivacy').is(':checked')) {
        $('.book-appintment-submit')
          .find('button[type="submit"]')
          .attr('disabled', false);
        isDisabled = false;
      } else {
        $('.book-appintment-submit')
          .find('button[type="submit"]')
          .attr('disabled', true);
        isDisabled = true;
      }
    });
  }

  constructor(element) {
    super(element);

    this.DetailResultsEl = this.element.find(
      this.Selectors.DetailResultContainer
    );
    this.MapEl = this.element.find(this.Selectors.DetailMap);
    this.ZoomIn = this.element.find(this.Selectors.ZoomIn);
    this.ZoomOut = this.element.find(this.Selectors.ZoomOut);
    this.BaGoto = this.element.find(this.Selectors.BaGoto);
    this.BaTarget = this.element.find(this.Selectors.BaTarget);
    this.subBrand = this.element[0].dataset.zmapSubBrand;

    this.onInitDetailMap();
    this.setDetailContentDimensions();
    this.basicPrivacyAcceptance();
    // this.goToBookAppointment();
  }
}

export { ZDetail };
